import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

class TextField extends Component {
    render() {
        const { type, label, name, disable, input, additionalLabel, eng, ...other } = this.props;
        const labelStyles = cx('fc-input__label', {
            'fc-input__label--hidden': !label,
            'fc-input__label--disable': disable
        })
        const inputStyles = cx('fc-input__input', {'fc-input__input--disable': disable})

        return (
            <div className="fc-input-wrapper">
                <input
                    type={type || 'text'}
                    name={name}
                    className={inputStyles}
                    value={input.value}
                    onChange={input.onChange}
                    {...other}/>
                <label className={labelStyles} htmlFor={name}>
                    {label} <span className="label-eng">[{eng}]</span>
                    <span className="aditionallabel">{additionalLabel}</span>
                </label>
            </div>
        )
    }
}

TextField.propTypes = {
    type: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    disable: PropTypes.bool,
    input: PropTypes.object,
    additionalLabel: PropTypes.string
}

export default TextField;



// WEBPACK FOOTER //
// ./src/modules/User/components/TextField.js